module.exports = __webpack_public_path__ + "media/images/pic/1-03a84455e6c4ca82b07f000d7a15c116.jpg";